module.exports = __webpack_public_path__ + "media/images/img/seikousya/loglass-6339b827c4bfbfc887dbd212c004eac7.png";